import React from 'react';
import FadeInSection from '../components/FadeInSection';

const Home: React.FC = () => {

  return (
    <div className="max-w-5xl mx-auto">
      <FadeInSection className="py-16" initialVisible={true}>
        <div className="grid md:grid-cols-2 gap-12">
          <div className="text-md">
          {/* <h1 className="text-2xl font-semibold mb-8 text-text-white"> */}
          <h1 className="font-semibold mb-8 text-text-white">
            Hi! I'm Thomas, a software engineer and researcher at Carnegie Mellon University's Software Engineering Institute
          </h1>
          <p className="mb-8 leading-relaxed text-text-gray">
            I work on network security tooling, focusing on network flow sensors, cloud telemetry integration, and ETL infrastructure that delivers high-quality data to security analysts.
          </p>
          <p className="mb-8 leading-relaxed text-text-gray">
            I'm also an amateur cyclist and triathlete - musician - father to a beautiful cat, Saphira - and most importantly, a dvorak user (btw).
          </p>
          </div>
          
          <div className="relative">
            {/* <div className="w-full max-w-sm mx-auto aspect-square rounded-lg border-b-2 border-primary overflow-hidden"> */}
            <div className="w-full max-w-sm mx-auto aspect-square rounded-lg overflow-hidden shadow-glow-sm hover:shadow-glow transition-shadow duration-300 bg-gray-800">
              <img 
                src="/thewave.jpg" 
                className="w-full h-full object-cover"
                style={{ 
                  transform: 'scale(1.4)', 
                  transformOrigin: '50% 80%',
                  objectPosition: '50% 100%' 
                }}
                alt=""
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </FadeInSection>

      <FadeInSection className="py-16">
        <h2 className="text-3xl font-normal mb-12 text-center text-text-white drop-shadow-glow-sm">
          my work
        </h2>
        <div className="text-md">
          <div className="space-y-6">
            <p className="leading-relaxed text-text-gray">
              I work at CERT on the network situational awareness team where I develop and maintain open source security tooling that analyzes tens of billions of packets every day.
            </p>
            <p className="leading-relaxed text-text-gray">
              My favorite thing about working at CERT is that it's a research and development center where curiosity drives the work. There's a strong culture of experimenting and taking ownership of problems, which aligns with my natural curiosity and desire to innovate. On the NetSA team, I get to design, implement, and test novel solutions that challenge the status quo of the current network security telemetry landscape, striving towards a more secure and efficient future.
               {/* We're encouraged to chase down pursue intriguing technical challenges and potentially build something that makes a real difference. */}
            </p>
          </div>
        </div>
      </FadeInSection>

      <FadeInSection className="py-16">
        <h2 className="text-3xl font-normal mb-12 text-center text-text-white drop-shadow-glow-sm">
          about me
        </h2>
        <div className="space-y-6 text-md">
            <p className="leading-relaxed text-text-gray">
              My greatest passion is creating. I've always valued creating over consuming and have enjoyed using many mediums over the years, from oil paints to instruments to computers. My second greatest passion is problem solving and finding unique solutions to tough challenges, believing that coming up with a great solution is worth every ounce of effort. Following my two greatest passions - creating and problem solving - led me down the path of software engineering.
            </p>
            <p className="leading-relaxed text-text-gray">
              My third greatest passion is moving through space, preferably on two wheels. I love cycling, motorcycling, running, skiing, swimming, hiking, and karting. My favorite place I've ridden a bike is Chamonix, France where I watched a stage of the 2023 Tour De France then rode to Switzerland. I transitioned from racing bikes to triathlons because I got tired of putting my bike (and myself) back together after crashes. I'm currently training for a marathon this fall.
            </p>
            <p className="leading-relaxed text-text-gray">
              I enjoy science fiction (namely Blade Runner, Syd Mead, and Gene Wolfe), my favorite movie is Trainspotting, my favorite music genre is IDM / intelligent dance music despite the pretentious name (Aphex Twin, Underworld, Squarepusher), and my favorite food was formerly strawberries and cream but I recently discovered tortas.
            </p>
          </div>
          
          <div className="grid md:grid-cols-2 gap-8 mt-12 pt-4">
            <div className="relative">
              {/* <div className="w-full max-w-sm mx-auto aspect-square rounded-lg border-b-2 border-primary overflow-hidden"> */}
              <div className="w-full max-w-sm mx-auto aspect-square rounded-lg overflow-hidden shadow-glow-sm hover:shadow-glow transition-shadow duration-300 bg-gray-800">
                <img 
                  src="/skiing.jpg" 
                  className="w-full h-full object-cover"
                  style={{ objectPosition: '50% 25%' }}
                  alt=""
                  loading="lazy"
                />
              </div>
            </div>
            <div className="relative">
              {/* <div className="w-full max-w-sm mx-auto aspect-square rounded-lg border-b-2 border-primary overflow-hidden"> */}
              <div className="w-full max-w-sm mx-auto aspect-square rounded-lg overflow-hidden shadow-glow-sm hover:shadow-glow transition-shadow duration-300 bg-gray-800">
                <img 
                  src="/me-2.jpg" 
                  className="w-full h-full object-cover object-left"
                  alt=""
                  loading="lazy"
                />
              </div>
            </div>
          </div>
      </FadeInSection>

      <FadeInSection className="py-16">
        <h2 className="text-3xl font-normal mb-12 text-center text-text-white drop-shadow-glow-sm">
          projects
        </h2>
        <p className="text-md text-text-gray text-center mb-12">
          A collection of some neat stuff I've made
        </p>
        <div className="grid gap-8">
          {projects.map((project, index) => (
            <div key={index} className="border border-gray-600 rounded-lg p-6 bg-bg-main transition-all duration-300 hover:border-gray-400 group">
              {project.link ? (
                <a 
                  href={project.link}
                  className="block"
                  {...(project.link.startsWith('http') && {
                    target: "_blank",
                    rel: "noopener noreferrer"
                  })}
                >
                  <div className="flex justify-between items-start mb-4">
                    <h2 className="text-xl font-semibold text-primary group-hover:text-text-white transition-colors drop-shadow-glow-sm group-hover:drop-shadow-glow">
                      {project.title}
                    </h2>
                  </div>
                  
                  <p className="leading-relaxed text-text-gray group-hover:text-text-white transition-colors">
                    {project.description}
                  </p>
                </a>
              ) : (
                <>
                  <div className="flex justify-between items-start mb-4">
                    <h2 className="text-xl font-semibold text-text-white group-hover:drop-shadow-glow transition-all">
                      {project.title}
                    </h2>
                  </div>
                  
                  <p className="mb-6 leading-relaxed text-text-gray group-hover:text-text-white transition-colors">
                    {project.description}
                  </p>
                </>
              )}
            </div>
          ))}
        </div>
      </FadeInSection>
    </div>
  );
};

const projects = [
  {
    title: "cleakr.nvim",
    description: "Neovim plugin that detects memory leaks in C code using AI and clang-tidy. Automatically analyzes C files and provides inline virtual text warnings with GPT-powered diagnostic summaries and recommendations.",
    technologies: ["Neovim", "Python", "Clang-tidy", "Lua", "Secure by Design"],
    link: "https://github.com/tgben/cleakr",
  },
  {
    title: "Chess Opening Success Analysis System",
    description: "High-performance distributed system that processed 125 million chess games using Apache Kafka and PostgreSQL with a React frontend for visualizing opening success rates.",
    technologies: ["Python", "Kafka", "PostgreSQL", "Docker", "React"],
    link: "https://github.com/tgben/chess",
  },
  {
    title: "Three Albums on Bandcamp",
    description: "Electronic and ambient music I've made and released under the alias <city> over the course of a handful of creatively inspired but sleepless nights between 2019 and 2022.",
    technologies: ["FL Studio", "Ableton"],
    link: "https://city.bandcamp.com/",
  },
  {
    title: "How I Learned Dvorak in 3 Weeks",
    description: "A blog post about my journey learning the Dvorak keyboard layout and building aoeu, a TUI Dvorak trainer for developers.",
    technologies: ["Dvorak", "Typing", "TUI"],
    link: "/blog/how-i-learned-dvorak-in-3-weeks",
  }
];

export default Home;
